var _rect, _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _circle, _circle2, _g2, _circle3, _circle4, _g3, _circle5, _circle6, _g4, _circle7, _circle8, _g5, _circle9, _circle0, _g6, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _ellipse, _ellipse2, _path20, _path21, _path22, _path23, _circle1, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecipientsBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 324,
    height: 148,
    viewBox: "0 0 324 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_40000087_32131",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -7,
    width: 324,
    height: 162
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -7,
    width: 324,
    height: 162,
    fill: "#013C74"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_40000087_32131)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M166.317 205.033C166.227 205.033 166.137 205.034 166.047 205.034C106.251 205.034 57.7773 146.447 57.7773 74.1769C57.7773 1.90681 106.251 -56.6797 166.047 -56.6797C166.137 -56.6797 166.227 -56.6796 166.317 -56.6793L374.757 -56.6797V205.22H166.317V205.033Z",
    fill: "#29B8FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_40000087_32131",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: -57,
    width: 318,
    height: 263
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M166.316 205.033C166.226 205.033 166.136 205.034 166.046 205.034C106.25 205.034 57.7759 146.447 57.7759 74.1769C57.7759 1.90681 106.25 -56.6797 166.046 -56.6797C166.136 -56.6797 166.226 -56.6796 166.316 -56.6793L374.756 -56.6797V205.22H166.316V205.033Z",
    fill: "#D3EFF8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_40000087_32131)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.19 156.52H266.466V25.998H283.19V156.52ZM271.135 125.626V136.438H274.635V125.626H271.135ZM271.135 116.359H274.635V105.547H271.135V116.359ZM271.135 96.2783H274.635V85.4658H271.135V96.2783ZM271.135 76.1992H274.635V65.3867H271.135V76.1992ZM271.135 56.1152H274.635V45.3027H271.135V56.1152Z",
    fill: "#89D0FE",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.312 25.9943L311.593 11.3203V156.516H286.312V25.9943Z",
    fill: "#89D0FE",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.704,
    y: 101.684,
    width: 16.3357,
    height: 54.8344,
    fill: "#89D0FE",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.507,
    y: 101.684,
    width: 16.3357,
    height: 54.8344,
    fill: "#89D0FE",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.954,
    y: 83.9199,
    width: 20.2252,
    height: 72.5977,
    fill: "#89D0FE",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.63 156.52H233.848V25.998L262.63 11.3242V156.52ZM237.347 115.586V125.627H259.128V115.586H237.347ZM237.347 109.407H259.128V99.3672H237.347V109.407ZM237.347 93.1904H259.128V83.1504H237.347V93.1904ZM237.347 76.9697H259.128V66.9297H237.347V76.9697ZM237.347 60.7549H259.128V50.7148H237.347V60.7549ZM237.347 44.5332H259.128V34.4932H237.347V44.5332Z",
    fill: "#89D0FE",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.7642,
    y: 90.0977,
    width: 19.4473,
    height: 66.4192,
    fill: "#89D0FE",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.3257,
    y: 56.1191,
    width: 26.0593,
    height: 100.401,
    fill: "#89D0FE",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.94 156.519H98.4932V34.4922H117.94V156.519ZM102.385 136.438V145.706H109.774V136.438H102.385ZM102.385 130.262H109.774V120.993H102.385V130.262ZM102.385 114.812H109.774V105.545H102.385V114.812ZM102.385 99.3672H109.774V90.0996H102.385V99.3672ZM102.385 83.9209H109.774V74.6523H102.385V83.9209ZM102.385 68.4756H109.774V59.208H102.385V68.4756ZM102.385 53.0303H109.774V43.7627H102.385V53.0303Z",
    fill: "#89D0FE",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.743 156.519H211.295V34.4922H230.743V156.519ZM215.186 136.438V145.706H222.576V136.438H215.186ZM215.186 130.262H222.576V120.993H215.186V130.262ZM215.186 114.812H222.576V105.545H215.186V114.812ZM215.186 99.3672H222.576V90.0996H215.186V99.3672ZM215.186 83.9209H222.576V74.6523H215.186V83.9209ZM215.186 68.4756H222.576V59.208H215.186V68.4756ZM215.186 53.0303H222.576V43.7627H215.186V53.0303Z",
    fill: "#89D0FE",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.052,
    y: 70.793,
    width: 19.4473,
    height: 85.7271,
    fill: "#89D0FE",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.243 178.425H143.462V0.0195312H165.243V178.425ZM145.95 166.447H163.064V160.269H145.95V166.447ZM145.95 147.91V154.089H163.064V147.91H145.95ZM145.95 141.729H163.064V135.551H145.95V141.729ZM145.95 129.375H163.064V123.196H145.95V129.375ZM145.95 117.019H163.064V110.84H145.95V117.019ZM145.95 104.659H163.064V98.4814H145.95V104.659ZM145.95 92.3047H163.064V86.126H145.95V92.3047ZM145.95 79.9482H163.064V73.7695H145.95V79.9482ZM145.95 67.5889H163.064V61.4111H145.95V67.5889ZM145.95 55.2344H163.064V49.0557H145.95V55.2344ZM145.95 42.874H163.064V36.6953H145.95V42.874ZM145.95 30.5166H163.064V24.3389H145.95V30.5166ZM145.95 18.1621H163.064V11.9844H145.95V18.1621Z",
    fill: "#89D0FE",
    fillOpacity: 0.3
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M206.818 104.24C209.842 100.352 251.998 59.7805 272.698 39.9805",
    stroke: "#FFC220",
    strokeWidth: 2.16
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M195.471 103.701L91.251 44.3008",
    stroke: "#FFC220",
    strokeWidth: 2.16
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M198.172 102.621L138.232 28.6406",
    stroke: "#FFC220",
    strokeWidth: 2.16
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M208.433 109.101C211.457 108.669 264.413 103.161 290.513 100.461",
    stroke: "#FFC220",
    strokeWidth: 2.16
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M190.629 105.455C186.642 104.506 133.509 99.1197 107.441 96.5449",
    stroke: "#FFC220",
    strokeWidth: 2.16
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 138.769,
    cy: 26.4801,
    r: 16.7398,
    fill: "#FF9E5C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_40000087_32131",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 122,
    y: 9,
    width: 34,
    height: 35
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 138.77,
    cy: 26.4801,
    r: 16.7398,
    fill: "#8CD1FC"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_40000087_32131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.422 17.515C134.422 17.515 134.795 14.5273 137.907 14.5273C141.02 14.5273 141.642 16.3946 141.642 16.3946L142.264 19.5067L144.505 22.7433C144.505 22.7433 143.136 24.4861 142.264 25.3574C141.393 26.2288 138.779 27.1002 138.779 27.1002C138.779 27.1002 136.912 26.9757 135.169 25.9799C133.426 24.984 132.555 23.6147 132.555 23.6147L134.173 20.1291L134.422 17.515Z",
    fill: "#211E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.758 39.9218L132.683 39.4238L130.941 42.4114C130.941 42.4114 129.945 48.3867 129.945 49.756C129.945 51.1253 132.061 66.0634 132.061 66.0634H145.007C145.007 66.0634 146.875 50.3784 146.875 47.5153C146.875 44.6522 144.758 39.9218 144.758 39.9218Z",
    fill: "#DEB599"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.692 28.5947C131.439 26.9764 137.041 24.1133 138.286 24.1133C139.531 24.1133 145.506 27.3499 146.253 28.0968C147 28.8437 149.24 34.9434 149.365 35.4413C149.489 35.9392 149.365 38.9269 148.742 39.4248C148.12 39.9227 145.879 39.4248 145.879 39.4248V40.4207L132.684 40.0472L130.692 45.898L130.194 48.3876H128.078C128.078 48.3876 127.829 45.4 127.829 44.0307C127.829 42.6614 129.572 38.9269 129.572 38.9269C129.572 38.9269 129.945 30.213 130.692 28.5947Z",
    fill: "#FF7208"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.999 32.3293L140.148 31.209V42.1636L146.248 43.5329L145.999 32.3293Z",
    fill: "#041E42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.27 36.6851C141.643 36.6851 143.137 36.5606 143.137 36.5606L143.261 35.6892C143.261 35.6892 142.141 34.9423 142.016 34.6933C141.892 34.4444 141.892 33.6974 141.892 33.573C141.892 33.4485 140.772 32.3281 140.772 32.3281C140.772 32.3281 140.523 32.5771 140.523 32.9505C140.523 33.324 141.021 34.0709 141.021 34.0709L140.772 34.8178C140.772 34.8178 140.025 33.573 139.651 33.4485C139.278 33.324 139.153 33.324 139.153 33.324C139.153 33.324 139.278 35.0668 139.651 35.6892C140.025 36.3116 140.896 36.6851 141.27 36.6851Z",
    fill: "#AD764A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.891 35.1914L146.875 35.3159L148.742 39.4239C148.742 39.4239 147.746 40.5442 146.75 40.1708C145.755 39.7973 142.394 37.3076 142.394 37.3076L142.891 35.1914Z",
    fill: "#FF7208"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.543 27.0997L138.535 29.4649L140.527 27.0997L139.904 23.4897C139.904 23.4897 141.024 22.3694 141.149 21.9959C141.273 21.6224 141.149 19.3817 141.149 19.3817C141.149 19.3817 139.904 18.8838 139.406 18.5104C138.908 18.1369 138.037 16.7676 138.037 16.7676C138.037 16.7676 137.611 17.8933 137.165 18.5104C136.622 19.2635 135.423 20.1286 135.423 20.1286C135.423 20.1286 135.298 21.9959 135.547 22.3694C135.796 22.7428 136.792 23.4897 136.792 23.4897L136.543 27.0997Z",
    fill: "#AD764A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.548 21.3745L137.308 21.25C137.308 21.25 137.557 22.2459 138.303 22.2459C139.05 22.2459 139.548 21.3745 139.548 21.3745Z",
    fill: "white"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.7036,
    cy: 41.0615,
    r: 12.9599,
    fill: "#8CD1FC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_40000087_32131",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 77,
    y: 28,
    width: 27,
    height: 27
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.705,
    cy: 41.0615,
    r: 12.9599,
    fill: "#041E42"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_40000087_32131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.0432 42.8451H91.2033H96.1257C96.2238 42.8451 96.3209 42.8252 96.4111 42.7865L97.6194 42.2687C97.9416 42.1306 98.1187 41.7816 98.0399 41.4399L98.0125 41.3212C97.9482 41.0427 98.0726 40.7548 98.3195 40.6108C98.6699 40.4064 98.7509 39.9352 98.4889 39.6255L98.4015 39.5222C98.1809 39.2616 98.2253 38.8691 98.4984 38.6642C98.7994 38.4385 98.8171 37.9934 98.535 37.7445L97.8773 37.1642C97.6865 36.9958 97.6525 36.7109 97.7985 36.5023C97.9883 36.2312 97.8672 35.8539 97.5552 35.7438L97.1575 35.6034C96.8499 35.4949 96.6527 35.1941 96.676 34.8687L96.6856 34.7338C96.7099 34.3941 96.4942 34.0833 96.1674 33.9872L95.6004 33.8204C95.3474 33.746 95.158 33.5353 95.1108 33.2759C95.0505 32.9441 94.7615 32.703 94.4243 32.703H94.1707C93.8637 32.703 93.5961 32.494 93.5216 32.1962C93.4391 31.8659 93.1216 31.6503 92.7842 31.6953L92.2961 31.7604C92.1174 31.7842 91.9362 31.7405 91.788 31.6379L91.2827 31.2881C91.0225 31.108 90.6736 31.126 90.4333 31.332C90.2889 31.4557 90.1002 31.515 89.9109 31.4961L88.9873 31.4038C88.6493 31.37 88.3389 31.5926 88.2626 31.9235C88.1843 32.2627 87.8608 32.4867 87.5158 32.4407L87.4299 32.4293C87.0552 32.3793 86.7051 32.6259 86.6258 32.9955L86.6172 33.0359C86.5456 33.3699 86.2504 33.6085 85.9088 33.6085H85.6692C85.2391 33.6085 84.9037 33.9811 84.9487 34.4088L84.9896 34.7969C85.0221 35.106 84.8295 35.3956 84.5323 35.487C84.1745 35.5971 83.9825 35.9879 84.1169 36.3373C84.2337 36.641 84.1024 36.9863 83.816 37.1405C83.4638 37.3301 83.3551 37.7903 83.5916 38.1128L83.7293 38.3005C83.9589 38.6136 83.9008 39.0521 83.5976 39.2946L83.5184 39.358C83.1466 39.6555 83.1579 40.2245 83.5412 40.507L84.1225 40.9353C84.3534 41.1054 84.4622 41.3957 84.3999 41.6756L84.336 41.9635C84.2354 42.4159 84.5797 42.8451 85.0432 42.8451Z",
    fill: "#E29700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0384 42.212L90.4795 40.582L93.4678 41.8498C93.4678 41.8498 96.6372 42.8459 96.9089 43.4798C97.1805 44.1137 97.7238 45.9248 97.7238 46.4681C97.7238 47.0114 97.905 52.2636 97.7238 52.5353C97.5427 52.8069 95.1883 53.4408 95.1883 53.4408C95.1883 53.4408 97.7238 58.7836 97.7238 59.7797C97.7238 60.7758 98.4483 72.8196 98.4483 72.8196C98.4483 72.8196 99.3538 74.359 99.5349 75.4457C99.7161 76.5323 99.9877 85.0445 99.9877 85.0445H98.4483C98.4483 85.0445 95.8222 79.0679 95.6411 78.434C95.46 77.8001 94.5544 72.8196 94.5544 72.8196L90.4795 61.4097L89.8456 69.0163L90.4795 85.4972H88.7589C88.7589 85.4972 85.8612 78.0718 85.8612 76.8945C85.8612 75.7173 85.4084 68.654 85.4084 68.654C85.4084 68.654 83.3256 61.3191 83.2351 59.9608C83.1445 58.6025 85.4084 53.8936 85.4084 53.8936C85.4084 53.8936 84.0501 53.8936 83.869 53.4408C83.6878 52.988 83.2351 49.0942 83.2351 48.3698C83.2351 47.6453 84.3217 44.0231 84.7745 43.4798C85.2273 42.9365 87.0384 42.212 87.0384 42.212Z",
    fill: "#00559B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1261 51.1772C88.3072 50.8149 88.1261 49.9094 88.1261 49.9094C88.1261 49.9094 86.8583 49.8188 86.4961 49.9094C86.1339 49.9999 86.2244 50.8149 86.2244 50.8149L87.5827 51.5394C87.5827 51.5394 87.945 51.5394 88.1261 51.1772Z",
    fill: "#F7C9AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7332 50.1799H93.8276C93.8276 50.1799 94.2804 49.2743 94.4615 49.0027C94.6426 48.731 95.9104 47.916 95.9104 47.916C95.9104 47.916 96.001 48.4593 95.9104 48.731C95.8198 49.0027 95.0954 49.6366 95.0954 49.6366L94.7332 50.1799Z",
    fill: "#F7C9AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2085 46.9211C88.8178 44.6197 89.1179 40.9444 89.1179 40.9444L90.5668 40.3105L92.3779 40.9444C92.3779 40.9444 92.5625 44.4661 92.1062 46.6494C91.818 48.0288 91.0196 50.0905 91.0196 50.0905H90.0235C90.0235 50.0905 89.4224 48.181 89.2085 46.9211Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3873 39.4946V41.4868C89.3873 41.4868 90.2023 42.1206 90.8362 42.1206C91.4701 42.1206 92.1039 41.4868 92.1039 41.4868V39.4946C92.1039 39.4946 92.4662 39.3134 92.5567 39.0418C92.6473 38.7701 92.7378 36.0535 92.7378 35.6007C92.7378 35.1479 91.9228 33.9707 90.6551 33.9707C89.3873 33.9707 88.7534 35.1479 88.7534 35.6007V39.0418C88.7534 39.3134 89.3873 39.4946 89.3873 39.4946Z",
    fill: "#F7C9AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5626 38.4089L89.9326 38.3184C89.9326 38.3184 90.1137 39.0428 90.6571 39.0428C91.2004 39.0428 91.5626 38.4089 91.5626 38.4089Z",
    fill: "#E55C00"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.5804,
    cy: 37.4849,
    rx: 0.36222,
    ry: 0.724439,
    transform: "rotate(-16.0323 88.5804 37.4849)",
    fill: "#F7C9AA"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.7361,
    cy: 37.483,
    rx: 0.36222,
    ry: 0.724439,
    transform: "rotate(15 92.7361 37.483)",
    fill: "#F7C9AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3867 35.692C90.93 35.3297 92.1978 33.8809 92.1978 33.8809H88.2133C88.1409 33.8809 88.0624 35.6316 88.0322 36.507C88.0322 36.507 89.8433 36.0542 90.3867 35.692Z",
    fill: "#E29700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3413 36.0826C92.0814 35.7329 91.4751 34.334 91.4751 34.334H93.3807C93.4153 34.334 93.4528 36.0243 93.4673 36.8695C93.4673 36.8695 92.6011 36.4324 92.3413 36.0826Z",
    fill: "#E29700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6477 42.7539L94.8249 44.6556L93.6477 45.5611L94.8249 46.3761L92.7422 49.2739",
    stroke: "#041E42",
    strokeWidth: 0.18111
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1249 42.3027L86.7666 44.4761L88.1249 45.3816L86.7666 46.3777L88.1249 48.7321",
    stroke: "#041E42",
    strokeWidth: 0.18111
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 275.93,
    cy: 36.2006,
    r: 31.3198,
    fill: "#0071DC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_40000087_32131",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 244,
    y: 4,
    width: 64,
    height: 64
  }, _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 275.931,
    cy: 36.2006,
    r: 31.3198,
    fill: "#29B8FF"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_40000087_32131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.405 41.7089C256.405 41.7089 266.661 33.4747 274.243 33.6958C281.194 33.8985 289.495 41.1918 289.495 41.1918C289.495 41.1918 302.162 55.1516 301.645 57.2197C301.128 59.2878 293.631 71.6448 293.631 72.4721C293.631 73.2993 290.529 71.438 288.978 70.404L293.631 59.2878L288.978 55.4101L286.651 81.7786H261.317L259.766 54.3761L251.235 60.5804L259.766 71.438L257.698 76.0913C257.698 76.0913 241.928 63.9421 241.153 61.3559C240.377 58.7698 256.405 41.7089 256.405 41.7089Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.881 21.2858L271.14 35.2456L276.31 39.3818L279.154 37.5722L278.895 31.8849H281.739L283.29 26.9731L283.549 19.9933L281.739 14.5645H274.759L272.949 19.2177L270.881 21.2858Z",
    fill: "#CC8B57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.88 15.3412C285.622 16.8923 283.037 18.1849 283.037 18.1849L273.73 20.5115L271.145 29.0425C271.145 29.0425 268.301 25.6818 267.267 24.1307C266.233 22.5796 265.975 18.1849 266.233 16.8923C266.492 15.5997 268.043 12.239 270.24 11.205C272.438 10.1709 277.867 11.205 277.867 11.205L282.778 8.36133C282.778 8.36133 286.139 13.7901 285.88 15.3412Z",
    fill: "#211E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.949 35.5041C271.398 34.4701 271.398 31.1094 270.881 31.1094C270.364 31.1094 269.071 33.6945 269.071 33.6945C269.071 33.6945 269.484 35.6813 270.105 36.7967C271.22 38.7959 274.5 40.6744 274.5 40.6744C275.62 40.3297 277.912 39.6403 278.119 39.6403C278.326 39.6403 279.24 39.985 279.67 40.1574L280.963 36.5382L278.895 33.436L277.861 38.6063C277.861 38.6063 274.5 36.5382 272.949 35.5041Z",
    fill: "#FFC220"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.208 25.1639L272.174 19.4766L270.881 20.2521L271.915 27.232L275.535 31.8852H281.739L283.29 26.9735L281.739 25.1639H277.344L275.276 28.0075L273.208 25.1639Z",
    fill: "#211E1F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.34178,
    cy: 2.76724,
    rx: 1.34178,
    ry: 2.76724,
    transform: "matrix(0.988292 -0.152573 0.170072 0.985432 268.295 20.4043)",
    fill: "#CC8B57"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 288.883,
    cy: 100.462,
    r: 18.36,
    fill: "#E29700"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_40000087_32131",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 270,
    y: 82,
    width: 38,
    height: 37
  }, _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 288.882,
    cy: 100.462,
    r: 18.36,
    fill: "#29B8FF"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_40000087_32131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.663 103.69C298.663 103.69 292.652 98.8632 288.207 98.9928C284.132 99.1116 278.751 103.374 278.751 103.374C278.751 103.374 275.507 114.661 275.81 115.874C276.114 117.086 276.546 123.477 276.546 123.962C276.546 124.447 278.357 124.568 279.266 123.962L278.751 118.08L280.222 114.403L280.933 127.179H295.784L296.398 111.722L298.663 118.08L297.133 126.903L302.28 127.179C302.28 127.179 301.09 118.86 301.545 117.344C301.999 115.828 298.663 103.69 298.663 103.69Z",
    fill: "#041E42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.176 91.7194L290.024 99.9028L286.993 102.327L285.326 101.267L285.478 97.9327H283.811L282.902 95.0534L282.75 90.9617L283.811 87.7793H287.903L288.963 90.5071L290.176 91.7194Z",
    fill: "#9B5627"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.426 89.1424C282.578 90.0517 283.053 89.9002 283.053 89.9002L285.367 88.6689L287.94 88.9447L288.308 90.1395L290.024 92.3452V96.265C290.024 96.265 291.691 94.2949 292.297 93.3857C292.903 92.4764 293.055 89.9002 292.903 89.1424C292.752 88.3847 291.843 86.4146 290.554 85.8085C289.266 85.2023 286.084 85.8085 286.084 85.8085L283.897 87.1984C283.897 87.1984 282.274 88.2332 282.426 89.1424Z",
    fill: "#041E42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.965 100.055C289.874 99.4486 289.874 97.4785 290.177 97.4785C290.48 97.4785 291.238 98.994 291.238 98.994C291.238 98.994 290.996 100.159 290.632 100.812C289.978 101.984 288.055 103.086 288.055 103.086C287.399 102.884 286.055 102.479 285.934 102.479C285.813 102.479 285.277 102.682 285.024 102.783L284.267 100.661L285.479 98.8424L286.085 101.873C286.085 101.873 288.055 100.661 288.965 100.055Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.786566,
    cy: 1.62219,
    rx: 0.786566,
    ry: 1.62219,
    transform: "matrix(-0.988292 -0.152573 -0.170072 0.985432 291.25 91.1426)",
    fill: "#9B5627"
  }))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.97,
    cy: 95.6017,
    r: 22.6798,
    fill: "#FFF7DC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_40000087_32131",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 78,
    y: 72,
    width: 46,
    height: 47
  }, _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.969,
    cy: 95.6017,
    r: 22.6798,
    fill: "#041E42"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_40000087_32131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.9911 80.3591C95.0835 79.0558 96.9429 76.6944 100.235 76.4992C103.938 76.2797 106.045 78.2813 107.899 81.4947C109.602 84.4471 109.116 87.1373 108.947 90.7473C108.573 98.7655 99.2328 106.121 99.2328 106.121C99.2328 106.121 94.0762 100.409 92.9183 94.7209C91.9124 89.7793 90.2885 84.7768 93.9911 80.3591Z",
    fill: "#FF7208"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1441 98.3677L100.505 94.8809L106.898 97.5928C106.898 97.5928 113.678 99.7237 114.259 101.08C114.84 102.436 116.002 106.31 116.002 107.472C116.002 108.635 116.39 119.87 116.002 120.451C115.615 121.032 110.578 122.388 110.578 122.388C110.578 122.388 116.002 133.817 116.002 135.948C116.002 138.079 117.552 163.843 117.552 163.843C117.552 163.843 119.489 167.136 119.877 169.461C120.264 171.785 120.845 189.994 120.845 189.994H117.552C117.552 189.994 111.934 177.209 111.547 175.853C111.159 174.497 109.222 163.843 109.222 163.843L100.505 139.435L99.1492 155.707L100.505 190.963H96.8246C96.8246 190.963 90.6258 175.078 90.6258 172.56C90.6258 170.042 89.6572 154.932 89.6572 154.932C89.6572 154.932 85.2018 139.241 85.0081 136.336C84.8144 133.43 89.6572 123.357 89.6572 123.357C89.6572 123.357 86.7515 123.357 86.3641 122.388C85.9767 121.42 85.0081 113.09 85.0081 111.54C85.0081 109.991 87.3327 102.242 88.3012 101.08C89.2698 99.9174 93.1441 98.3677 93.1441 98.3677Z",
    fill: "#00559B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.467 117.544C95.8544 116.769 95.467 114.832 95.467 114.832C95.467 114.832 92.755 114.638 91.9801 114.832C91.2053 115.026 91.399 116.769 91.399 116.769L94.3047 118.319C94.3047 118.319 95.0795 118.319 95.467 117.544Z",
    fill: "#F7C9AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.607 115.413H107.67C107.67 115.413 108.638 113.476 109.026 112.895C109.413 112.314 112.125 110.57 112.125 110.57C112.125 110.57 112.319 111.733 112.125 112.314C111.932 112.895 110.382 114.251 110.382 114.251L109.607 115.413Z",
    fill: "#F7C9AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1757 92.5548V95.9403C98.1757 95.9403 94.215 97.9493 94.9219 99.999C95.541 101.794 100.788 104.54 101.421 104.54C102.054 104.54 106.694 101.283 107.155 99.4881C107.681 97.4384 103.987 96.2525 103.987 96.2525V92.5548C103.987 92.5548 104.762 92.1674 104.956 91.5862C105.149 91.0051 105.343 85.1937 105.343 84.2251C105.343 83.2566 103.6 80.7383 100.888 80.7383C98.1757 80.7383 96.8198 83.2566 96.8198 84.2251V91.5862C96.8198 92.1674 98.1757 92.5548 98.1757 92.5548Z",
    fill: "#F7C9AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.831 90.2308L99.3438 90.0371C99.3438 90.0371 99.7312 91.5868 100.893 91.5868C102.056 91.5868 102.831 90.2308 102.831 90.2308Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.4452,
    cy: 88.254,
    rx: 0.774855,
    ry: 1.54971,
    transform: "rotate(-16.0323 96.4452 88.254)",
    fill: "#F7C9AA"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 105.329,
    cy: 88.2541,
    rx: 0.774855,
    ry: 1.54971,
    transform: "rotate(15 105.329 88.2541)",
    fill: "#F7C9AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.646 84.5566C103.085 83.7058 106.444 80.3027 106.444 80.3027H95.8894C95.6975 80.3027 95.4896 84.4148 95.4097 86.4708C95.4097 86.4708 100.207 85.4073 101.646 84.5566Z",
    fill: "#FF7208"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.003 23.2402C192.695 23.2402 183.529 32.4067 183.529 43.714C183.529 43.714 182.176 56.7178 188.122 64.2133C194.068 71.7088 214.861 71.9971 219.689 64.2133C224.518 56.4295 224.477 43.714 224.477 43.714C224.477 32.4067 215.31 23.2402 204.003 23.2402Z",
    fill: "#041E42"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M195.964 71.4533C195.964 68.9434 195.791 65.347 195.445 60.6641L212.55 61.1839C212.205 65.6887 212.032 69.19 212.032 71.6877C212.032 76.1002 218.098 80.0855 230.229 83.6436C236.203 85.3958 240.565 90.5296 241.329 96.708L245.676 131.858C245.765 132.581 245.714 133.315 245.525 134.019C244.714 137.035 241.185 142.101 238.169 141.29H169.541H155.305L152.446 140.03V127.265L165.246 94.2441C166.898 89.3329 170.879 85.5613 175.872 84.1767C189.267 80.4633 195.964 76.2222 195.964 71.4533Z",
    fill: "#CD8B52"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M176.833 83.9062C185.516 89.8741 194.283 92.8999 203.132 92.9836C213.09 93.0779 224.091 89.6448 231.034 87.4779C232.713 86.9539 234.155 86.504 235.287 86.1958C238.575 88.6966 240.806 92.4545 241.332 96.7073L245.678 131.857C245.759 132.512 245.826 133.609 245.678 134.251H152.18V129.663C152.18 127.281 152.645 124.922 153.55 122.719L165.249 94.2435C166.9 89.3323 170.881 85.5607 175.875 84.1761C176.198 84.0864 176.517 83.9965 176.833 83.9062Z",
    fill: "#FFC220"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M195.464 60.666C195.863 67.9069 201.897 73.6563 209.282 73.6563C210.325 73.6563 211.341 73.5417 212.318 73.3244C212.128 72.786 212.033 72.2409 212.033 71.6892C212.033 69.1914 212.206 65.6901 212.551 61.1853L195.464 60.666Z",
    fill: "#211E1F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M204.123 28.4434C196.823 28.4434 190.905 34.3609 190.905 41.6606V55.7696C190.905 63.0693 196.823 68.9868 204.123 68.9868C211.422 68.9868 217.34 63.0693 217.34 55.7696V41.6606C217.34 34.3609 211.422 28.4434 204.123 28.4434Z",
    fill: "#CD8B52"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M208.026 59.5605H199.807C199.607 59.5605 199.476 59.7587 199.57 59.9353C200.024 60.7907 201.367 62.8138 203.916 62.8138C206.466 62.8138 207.809 60.7907 208.263 59.9353C208.357 59.7587 208.226 59.5605 208.026 59.5605Z",
    fill: "#9D4000"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M190.28 48.2812H191.81C193.534 48.2812 194.932 49.6792 194.932 51.4036V52.9557C194.932 54.6801 193.534 56.0781 191.81 56.0781H190.28C188.555 56.0781 187.157 54.6801 187.157 52.9557V51.4036C187.157 49.6792 188.555 48.2812 190.28 48.2812Z",
    fill: "#CD8B52"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M216.196 48.2812H217.726C219.45 48.2812 220.848 49.6792 220.848 51.4036V52.9557C220.848 54.6801 219.45 56.0781 217.726 56.0781H216.196C214.471 56.0781 213.073 54.6801 213.073 52.9557V51.4036C213.073 49.6792 214.471 48.2812 216.196 48.2812Z",
    fill: "#CD8B52"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.219 30.5179L204.261 25.8398L190.785 30.5179L189.23 34.6762C189.23 34.6762 187.694 35.182 190.785 37.329C193.875 39.4759 195.573 41.0318 201.938 42.7292C208.303 44.4265 212.122 44.8509 217.78 44.8509L219.292 39.8741L217.219 30.5179Z",
    fill: "#041E42"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M196.817 51.3621C195.958 51.3621 195.262 52.2233 195.262 51.3621C195.262 50.5009 195.958 49.8027 196.817 49.8027C197.675 49.8027 198.372 50.5009 198.372 51.3621C198.372 52.2233 197.675 51.3621 196.817 51.3621Z",
    fill: "#041E42"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M210.781 51.3621C209.923 51.3621 209.226 52.2233 209.226 51.3621C209.226 50.5009 209.923 49.8027 210.781 49.8027C211.64 49.8027 212.336 50.5009 212.336 51.3621C212.336 52.2233 211.64 51.3621 210.781 51.3621Z",
    fill: "#041E42"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.482 56.6509C199.606 56.6509 202.139 54.1184 202.139 50.9944C202.139 47.8704 199.606 45.3379 196.482 45.3379C193.358 45.3379 190.826 47.8704 190.826 50.9944C190.826 54.1184 193.358 56.6509 196.482 56.6509ZM196.482 57.1392C199.876 57.1392 202.627 54.3881 202.627 50.9944C202.627 47.6007 199.876 44.8496 196.482 44.8496C193.089 44.8496 190.337 47.6007 190.337 50.9944C190.337 54.3881 193.089 57.1392 196.482 57.1392Z",
    fill: "#041E42"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.965 56.6509C214.089 56.6509 216.621 54.1184 216.621 50.9944C216.621 47.8704 214.089 45.3379 210.965 45.3379C207.841 45.3379 205.308 47.8704 205.308 50.9944C205.308 54.1184 207.841 56.6509 210.965 56.6509ZM210.965 57.1392C214.358 57.1392 217.109 54.3881 217.109 50.9944C217.109 47.6007 214.358 44.8496 210.965 44.8496C207.571 44.8496 204.82 47.6007 204.82 50.9944C204.82 54.3881 207.571 57.1392 210.965 57.1392Z",
    fill: "#041E42"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.068 51.2383H202.504V50.75H205.068V51.2383Z",
    fill: "#041E42"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 236.095,
    cy: 133.206,
    rx: 10.5537,
    ry: 8.22363,
    fill: "#CD8B52"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 161.315,
    cy: 126.19,
    rx: 9.13661,
    ry: 8.19607,
    fill: "#CD8B52"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M147.115 69.5098C146.853 68.3049 147.618 67.1163 148.823 66.855C149.963 66.6077 151.101 67.2798 151.435 68.3975L155.859 83.2022L150.344 84.3983L147.115 69.5098Z",
    fill: "#BC804D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M149.594 80.3746L159.683 79.031L170.174 124.311L152.169 126.595L149.594 80.3746Z",
    fill: "#CD8B52"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M130.892 66.7054C130.695 66.7863 130.615 67.0234 130.723 67.2076L138.374 80.2589C139.001 81.3285 140.148 81.9856 141.387 81.9856H160.346C160.346 78.1878 157.162 75.1664 153.369 75.366L142.361 75.9454L135.503 67.8345C134.374 66.4984 132.512 66.0425 130.892 66.7054Z",
    fill: "#CD8B52"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M170.981 95.338C170.981 94.9399 171.304 94.6172 171.702 94.6172H235.856C236.254 94.6172 236.577 94.9399 236.577 95.338V132.1H170.981V95.338Z",
    fill: "#9B9B9B"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 204.095,
    cy: 113.184,
    r: 6.85246,
    fill: "#E8E8E8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M170.981 131.281H236.577V133.396C236.577 133.794 236.254 134.117 235.856 134.117H171.702C171.304 134.117 170.981 133.794 170.981 133.396V131.281Z",
    fill: "#686868"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M322.378 133.939H93.9584C93.0637 133.939 92.3384 134.665 92.3384 135.559V153.379C92.3384 154.274 93.0637 154.999 93.9584 154.999H322.378C323.273 154.999 323.998 154.274 323.998 153.379V135.559C323.998 134.665 323.273 133.939 322.378 133.939Z",
    fill: "#041E42"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipientsBanner);
export default __webpack_public_path__ + "static/media/Recipients_banner.19fad4e93f1067ffc11830cb498686da.svg";
export { ForwardRef as ReactComponent };